import React from "react";
import Card from "apollo-react/components/Card";
import CardContent from "apollo-react/components/CardContent";
import CardActions from "apollo-react/components/CardActions";
import Button from "apollo-react/components/Button";
import Typography from "apollo-react/components/Typography";
import flowTypeImage from "../../assets/images/flow_type_image.png"; 

const GenericCard = ({
  label,
  description,
  buttonLabel = "View Details",
  onButtonClick,
  children,
  imageId,
}) => {
  const getImageUrl = () => {
    if (imageId) {
      const baseURL = process.env.REACT_APP_SERVER_URL || 'http://localhost:6001';
      return `${baseURL}/api/v1/files/preview/${imageId}`;
    }
    return flowTypeImage;
  };

  return (
    <Card
      style={{
        width: 375,
        minHeight: 372,
        display: "flex",
        flexDirection: "column",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${getImageUrl()})`,
        cursor: onButtonClick ? "pointer" : undefined,
        overflow: "hidden",
        borderRadius: 0,
        border: "none",
      }}
      onClick={onButtonClick}
    >
      <CardContent
        style={{
          height: "100%",
          width: "100%",
          padding: 0,
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        {label && (
          <Typography
            variant="bodyDefault"
            style={{
              fontSize: 29,
              paddingLeft: 16,
              paddingTop: 16,
              paddingBottom: 16,
              display: "flex",
              alignItems: "center",
              fontWeight: 700,
              color: "#fff",
							fontFamily: "Proxima Nova",
              lineHeight: 1,
              backgroundColor: "rgba(0, 85, 135, 0.6)"
            }}
          >
            {label}
          </Typography>
        )}

        {children}
        <CardActions style={{ width: "100%", justifyContent: "center", padding: "25px 18px" }}>
          <Button
            variant="secondary"
            style={{
              background: "#fff",
              color: "#015FF1",
              fontWeight: 600,
              borderRadius: 50,
              border: "none",
              minWidth: "100%",
              boxShadow: "0px 1px 1px 0px #00000040",
            }}
            onClick={e => {
              e.stopPropagation();
              if (onButtonClick) onButtonClick();
            }}
          >
            {buttonLabel}
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

export default GenericCard;
